import React, { useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import '../../styles/StreamingPlatforms.css';
import axios from "axios";

const movieGenres = {
    Action: 28,
    Adventure: 12,
    Animation: 16,
    Comedy: 35,
    Crime: 80,
    Documentary: 99,
    Drama: 18,
    Fantasy: 14,
    Horror: 27,
    Romance: 10749,
    ScienceFiction: 878,
    Thriller: 53,
};

const tvShowGenres = {
    ActionAdventure: 10759,
    Animation: 16,
    Comedy: 35,
    Crime: 80,
    Documentary: 99,
    Drama: 18,
    Family: 10751,
    Kids: 10762,
    Mystery: 9648,
    Reality: 10764,
    SciFiFantasy: 10765,
    Soap: 10766,
    Talk: 10767,
    WarPolitics: 10768,
    Western: 37,
};

const MovieRoulette = ({ userRegion, partnerRegion }) => {
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [selectedType, setSelectedType] = useState("movies");
    const [selectedGenre, setSelectedGenre] = useState(null);
    const [randomItem, setRandomItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [spinning, setSpinning] = useState(false);
    const [finished, setFinished] = useState(false);

    const wheelRef = useRef(null);

    const platformOptions = [
        { label: "All Platforms", value: "all" },
        { label: "Netflix", value: "8" },
        { label: "Amazon Prime Video", value: "9" },
        { label: "Disney Plus", value: "337" },
        { label: "Apple TV Plus", value: "350" },
    ];

    const genreOptions = Object.keys(selectedType === "movies" ? movieGenres : tvShowGenres)
        .map(genre => ({ label: genre, value: selectedType === "movies" ? movieGenres[genre] : tvShowGenres[genre] }));

    const handleRoulette = async () => {
        if (!selectedPlatform) {
            setError("Please select a platform");
            return;
        }

        setRandomItem(null);
        setLoading(true);
        setError(null);
        setFinished(false);

        // Reiniciar animación de la rueda
        if (wheelRef.current) {
            wheelRef.current.classList.remove("spinning");
            void wheelRef.current.offsetWidth;
            wheelRef.current.classList.add("spinning");
        }

        setSpinning(true);

        try {
            let platformToUse = selectedPlatform;

            if (selectedPlatform === "all") {
                const availablePlatforms = platformOptions
                    .filter(option => option.value !== "all")
                    .map(option => option.value);
                const randomIndex = Math.floor(Math.random() * availablePlatforms.length);
                platformToUse = availablePlatforms[randomIndex];
            }

            const params = {
                platform: platformToUse,
                contentType: selectedType,
                region1: userRegion,
            };

            if (partnerRegion) {
                params.region2 = partnerRegion;
            }

            if (selectedGenre) {
                params.genre = selectedGenre;
            }

            const response = await axios.get("https://api.frazza.online/randomContent", { params });

            setTimeout(() => {
                setRandomItem(response.data);
                setSpinning(false);
                setFinished(true);
                setLoading(false);
            }, 2000);
        } catch (error) {
            console.error("Error fetching random content:", error);
            setError("No content found matching your criteria. Try different options.");
            setRandomItem(null);
            setSpinning(false);
            setFinished(true);
            setLoading(false);
        }
    };

    const handleSpinAgain = () => {
        setFinished(false);
        setTimeout(() => {
            handleRoulette();
        }, 100);
    };

    const handleReturnToRoulette = () => {
        setFinished(false);
    };

    return (
        <div className="movie-roulette-layout">
            <div className="roulette-section">
                <h2 className="roulette-title">Movie Roulette</h2>

                {!finished ? (
                    <div className="roulette-wrapper">
                        <div className="roulette-pointer"></div>
                        <div
                            ref={wheelRef}
                            className={`wheel-placeholder ${spinning ? "spinning" : ""}`}
                        ></div>
                    </div>
                ) : (
                    randomItem && (
                        <div className="roulette-result">
                            <h2>Winner:</h2>
                            <h3>{randomItem.title || randomItem.name}</h3>
                            {randomItem.poster_path && (
                                <img
                                    src={`https://image.tmdb.org/t/p/w500${randomItem.poster_path}`}
                                    alt={randomItem.title || randomItem.name}
                                    className="winner-poster"
                                />
                            )}
                            {randomItem.overview && (
                                <p className="overview">{randomItem.overview}</p>
                            )}
                            <div className="additional-info">
                                {randomItem.vote_average && <p>Rating: {randomItem.vote_average.toFixed(1)}/10</p>}
                                {randomItem.release_date && <p>Release Date: {randomItem.release_date}</p>}
                                {randomItem.first_air_date && <p>First Air Date: {randomItem.first_air_date}</p>}
                            </div>

                            {/* Botón Spin Again */}
                            <Button
                                label="Spin Again"
                                icon="pi pi-refresh"
                                onClick={handleSpinAgain}
                                className="spin-button"
                                style={{ marginTop: '2rem' }}
                            />

                            {/* Botón Return to Roulette */}
                            <Button
                                icon="pi pi-arrow-left"
                                className="p-button-rounded p-button-text return-btn"
                                onClick={handleReturnToRoulette}
                            />

                        </div>
                    )
                )}
            </div>

            {!finished && (
                <div className="filter-section">
                    <Dropdown
                        value={selectedPlatform}
                        options={platformOptions}
                        onChange={(e) => setSelectedPlatform(e.value)}
                        placeholder="Select Platform"
                    />
                    <Dropdown
                        value={selectedType}
                        options={[
                            { label: "Movies", value: "movies" },
                            { label: "TV Shows", value: "show" },
                        ]}
                        onChange={(e) => {
                            setSelectedType(e.value);
                            setSelectedGenre(null);
                        }}
                        placeholder="Select Type"
                    />
                    <Dropdown
                        value={selectedGenre}
                        options={genreOptions}
                        onChange={(e) => setSelectedGenre(e.value)}
                        placeholder="Select Genre"
                    />

                    <Button
                        label="Spin the Roulette"
                        icon="pi pi-refresh"
                        onClick={handleRoulette}
                        disabled={loading || !selectedPlatform}
                        className="spin-button"
                    />

                    {error && <p className="error-message">{error}</p>}
                </div>
            )}
        </div>
    );
};

export default MovieRoulette;
